import React from 'react';
import './ProductCard.css';
import { useNavigate } from 'react-router-dom';
import { useSettings } from '../contexts/SettingsContext';
import { priceConsultUrl } from '../utils/whatsapp';

const ProductCard = React.memo(function ProductCard({ product, image, lang, labels, addToCartLabel }) {
  const navigate = useNavigate();
  const { catalogueMode, loading: settingsLoading } = useSettings();
  const handleCardClick = (e) => {
    if (!product.id) {
      e.preventDefault();
      console.error("No subfamily ID found for navigation");
      alert("Este producto no tiene una subfamilia asignada");
    } else {
      // Preserve familia param in URL if present
      const params = new URLSearchParams(window.location.search);
      const familiaId = params.get('familia');
      const url = familiaId ? `/product/${product.id}?familia=${familiaId}` : `/product/${product.id}`;
      navigate(url);
    }
  };
  
  return (
    <div
      className="product-card"
      onClick={handleCardClick}
    >
      <div className="product-card-image">
        <img
          src={image}
          alt={product.name || product.nombre}
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className="product-card-content">
        <div className="product-card-title" style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          width: '100%',
          marginBottom: '8px',
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '1.1em',
          minHeight: '2.6em' // ensures space for 2 lines
        }}>
          {product.nombre}
        </div>
        <div className="product-prices" style={{ width: '100%' }}>
          <div className="product-card-price-group" style={{ width: '100%', textAlign: 'center', display: 'block', minHeight: '3.2em', paddingBottom: '4px' }}>
            {settingsLoading ? null : catalogueMode ? (
              <a
                className="product-card-consult"
                href={priceConsultUrl({ nombre: product.nombre })}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                style={{ display: 'inline-block', fontWeight: 'bold', color: '#25D366' }}
              >
                {lang === 'en' ? 'Ask for price' : 'Consultar precio'}
              </a>
            ) : (
              <>
                <span className="product-card-price">DESDE ₡{product.price || product.precio1}</span>
                <span className="product-card-price-detail" style={{ display: 'block', marginTop: '4px', whiteSpace: 'normal', overflow: 'visible', textOverflow: 'unset' }}>precio al detalle</span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default ProductCard;